export default __webpack_public_path__ + "static/media/warpage_2.2.35574b96.png";